export default "__VITE_ASSET__BXs5x9GL__"